import React, {useState} from 'react'
import {useGetAllBaLogsByDeviceIdQuery} from "../../../core/api/charge-log-api";
import Loading from "../../../components/Common/Loading";
import ChargerLogs from "../index";
import columns from "../chargerLogColumns";

export default function DeviceBaChargerLogs(props) {
    const [state, setState] = useState({
        page: 0,
        pageSize: 20,
    });

    const {
        data: response = {
            chargeLogs: [],
            totalPages: 1
        },
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetAllBaLogsByDeviceIdQuery({
        deviceId: props.deviceId,
        page: state.page,
        pageSize: state.pageSize
    })

    return (
        <>
            <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
            >
                <ChargerLogs columns={columns.BA} response={response} state={state} setState={setState}/>
            </Loading>
        </>
    )
}